<template>
    <page>
		<module v-if="power('b_home_work')" title="经营数据" height="auto">
			<template #head>
				<div class="sales-total-tab flex-center">
					<span>统计周期：{{salesPeriod[0] || '-'}} 至 {{salesPeriod[1] || '-'}}</span>
					<ul class="flex">
						<li :class="{'z-crt': currentSalesTab == 7}" @click="salesTabHandle(7)">近7天</li>
						<li :class="{'z-crt': currentSalesTab == 15}" @click="salesTabHandle(15)">近15天</li>
						<li :class="{'z-crt': currentSalesTab == 30}" @click="salesTabHandle(30)">近30天</li>
						<li :class="{'z-crt': currentSalesTab == 0}" @click="salesTabHandle(0)">自定义 <i class="tf">&#xe685;</i></li>
					</ul>
					<el-date-picker
					  v-model="currentSalesDate"
					  class="picker"
					  ref="picker"
					  type="datetimerange"
					  value-format="yyyy-MM-dd HH:mm:ss"
					  :default-time="['00:00:00', '23:59:59']"
					  @change="salesTabHandle(0, $event)"
					></el-date-picker>
				</div>
			</template>
			
			<div class="sales-total flex">
				<div v-for="(item, i) in businessDataList" :key="i" v-show="i < 4" class="item flex-grow flex-center" :class="{'z-active': item.to_page}" @click="item.to_page ? navigateTo(item.to_page) : ''">
					<div class="flex-grow">
						<label>{{item.name}}</label>
						<div class="value">{{item.tody_count}}</div>
						<p v-if="item.yesterday_count!=null">
							<span>较上周期：{{item.yesterday_count}}</span>
							<span v-if="item.ratio != 0">{{item.ratio}}%</span>
							<i v-if="item.ratio > 0" class="tf tf-sort-up" style="color: #EB0000"></i>
							<i v-if="item.ratio < 0" class="tf tf-sort-down" style="color: green"></i>
						</p>
					</div>
					<i v-if="i == 0" class="icon tf">&#xe698;</i>
					<i v-if="i == 1" class="icon tf">&#xe6ea;</i>
					<i v-if="i == 2" class="icon tf">&#xe64c;</i>
					<i v-if="i == 3" class="icon tf">&#xe604;</i>
				</div>
			</div>
		</module>

        <module v-if="power('b_home_work')" title="实时概况" height="auto">
            <div class="realtime-total flex-wrap">
				<div v-for="(item, i) in todayDataList" :key="i" class="item-box">
					<div class="item flex-column flex-center-main" :class="{'z-active': item.to_page}"
						@click="item.to_page ? navigateTo(item.to_page) : ''">
                        <label>{{item.name}}</label>
                        <div>{{item.tody_count}}</div>
                        <p v-if="item.yesterday_count!=null">
                            <span>昨日：{{item.yesterday_count}}</span>
                            <span v-if="item.ratio != 0">{{item.ratio}}%</span>
                            <i v-if="item.ratio > 0" class="tf tf-sort-up" style="color: #EB0000"></i>
                            <i v-if="item.ratio < 0" class="tf tf-sort-down" style="color: green"></i>
                        </p>
                    </div>
                </div>
            </div>
        </module>

        <module-group v-if="power('b_home_work')" height="auto">
			<module title="待办事项">
                <div class="backlog flex-wrap">
                    <div v-for="(item, i) in stayDataList" :key="i" class="item-box">
                        <!-- <div class="item" v-if="power(item.unique_key)" @click="navigateTo(item.to_page);"> -->
                        <div class="item" @click="navigateTo(item.to_page);">
                            <div>{{item.value}}</div>
                            <label>{{item.name}}</label>
                        </div>
                    </div>
                </div>
            </module>

            <module title="常用功能">
                <div class="history flex-wrap">
                    <div v-for="(item, i) in commonFunList" :key="i" class="item-box">
                        <div class="item" @click="navigateTo({name:item.key});">{{item.name}}</div>
                    </div>
                </div>
            </module>
        </module-group>

        <module v-if="power('b_home_work') && power('m_retail_order')" title="销售动态(近15天)">
            <charts type="bar" :data="salesChartsData" height="375"></charts>
        </module>

    </page>
</template>

<script>
	import charts from '@/components/charts/index.vue'
    import {mapGetters} from 'vuex'

	export default {
		name: 'home',
		
		components: {
			charts
		},
		
		data() {
			return {
				currentSalesTab: 7,
				currentSalesDate: [],
				salesPeriod: [],
				
				businessDataList: [],
                todayDataList: [],
                stayDataList: [],
                commonFunList: [],
                salesChartsData: [],
                returnChartsData: []
            }
		},
        computed: {
            ...mapGetters(['power'])
        },

        mounted() {
			this.salesTabHandle(7);
            this.getTodayData();
            this.getStayItems();
            this.getCommonFun();
            this.getSalesCharts();
            // this.getReturnCharts();
        },


        methods: {
			//经营数据
			salesTabHandle(tab, date) {
				if (tab) {
					this.currentSalesTab = tab;
					this.getBusinessData();
				} else {
					if (date) {
						this.currentSalesTab = 0;
						this.getBusinessData();
					} else {
						this.currentSalesDate = [];
						this.$refs.picker.$el.click();
					}
				}
			},
			
			getBusinessData(){
				this.request({
				    url: '/workbench/business',
					data: {
						query_type: this.currentSalesTab ? 1 : 2,
						days: this.currentSalesTab,
						begin_date: this.currentSalesTab ? '' : this.currentSalesDate[0],
						end_date: this.currentSalesTab ? '' : this.currentSalesDate[1]
					},
				    success: data => {
				        this.businessDataList = data.list;
						this.salesPeriod = [data.begin_date, data.end_date];
				    }
				});
			},
            // 今日实时数据
            getTodayData() {
                this.request({
                    url: '/workbench/today',
                    success: data => {
                        this.todayDataList = data;
                    }
                });
            },

            // 待办事项
            getStayItems() {
                this.request({
                    url: '/workbench/stayItem',
                    success: data => {
                        this.stayDataList = data;
                    }
                });
            },

            // 常用功能
            getCommonFun() {
                this.request({
                    url: '/workbench/common_func',
                    success: data => {
                        this.commonFunList = data;
                    }
                });
            },

            getSalesCharts() {
                this.request({
                    url: '/workbench/saleDynamic',
                    success: data => {
                        this.salesChartsData = [{
                            type: '支付金额',
                            data: Array.from(data, item => {
                                return {
                                    name: item.title,
                                    value: item.payment_money
                                }
                            })
                        }, {
                            type: '下单金额',
                            data: Array.from(data, item => {
                                return {
                                    name: item.title,
                                    value: item.placean_order_money
                                }
                            })
                        }];
                    }
                });
            },

            getReturnCharts() {
                this.request({
                    url: '/workbench/returnDynamic',
                    success: data => {
                        this.returnChartsData = [{
                            type: '退款金额',
                            data: Array.from(data, item => {
                                return {
                                    name: item.title,
                                    value: item.refundMoney
                                }
                            })
                        }, {
                            type: '退货金额',
                            data: Array.from(data, item => {
                                return {
                                    name: item.title,
                                    value: item.returnMoney
                                }
                            })
                        }];
                    }
                });
            }


        }
	}
</script>

<style lang="stylus" scoped>
  @import '~@/assets/style/theme';

  .welcome {
    background: linear-gradient(180deg, #FFFFFF, #EDFBFF);

    img {
      width: 550px;
    }
  }

	.sales-total {
		gap: 20px;
		margin: 20px;

		&-tab {
			position: relative;
			margin-right: 20px;

			span {
				margin-right: 12px;
				font-size: 12px;
				color: #999;
			}

			ul {
				li {
					width: 64px;
					border: 1px solid #ddd;
					margin-left: -1px;
					line-height: 24px;
					font-size: 12px;
					text-align: center;
					color: #666;
					cursor: pointer;

					&:not(.z-crt):hover {
						theme-color(main)
					}

					&.z-crt {
						color: #fff;
						theme-border(main)
						theme-background(main)
					}
				}
			}
			
			.picker {
				position: absolute;
				right: 0;
				top: 0;
				width: 65px;
				height: 26px;
				opacity: 0;
				pointer-events: none;
			}
		}

		.item {
			box-sizing: border-box;
			height: 140px;
			padding: 0 26px 0 22px;
			background: #F9F9F9;

			label {
				font-size: 14px;
				color: #666;
			}

			.value {
				margin: 10px 0;
				font-size: 30px;
				font-weight: bold;
			}

			p {
				font-size: 12px;
				color: #666;

				span:nth-child(n+2) {
					margin-left: 1em;
				}

				.tf {
					margin-left: .5em;
				}
			}

			.icon {
				font-size: 40px;
				color: #ccc;
			}
		}
	}

  .realtime-total {
    margin-left: 20px;
    margin-bottom: 20px;

    .item {
      box-sizing: border-box;
      height: 114px;
      border: 1px solid #eee;
			padding: 12px 26px;

      &.z-active {
        cursor: pointer;

        &:hover {
          theme-border(main)
        }
      }

      &-box {
        box-sizing: border-box;
        width: 16.6666%;
        padding-right: 20px;
        padding-top: 20px;

        @media screen and (max-width: 1700px) {
          & {
            width: 20%;
          }
        }
        @media screen and (max-width: 1400px) {
          & {
            width: 25%;
          }
        }
        @media screen and (max-width: 1200px) {
          & {
            width: 33.3333%;
          }
        }
        @media screen and (max-width: 900px) {
          & {
            width: 50%;
          }
        }
      }

      label {
        font-size: 14px;
        color: #666;
      }

      div {
				margin-top: 6px;
        font-size: 30px;
        font-weight: bold;
      }

      p {
				margin-top: 6px;
        font-size: 12px;
        color: #666;

        span:nth-child(n+2) {
          margin-left: 1em;
        }

        .tf {
          margin-left: .5em;
        }
      }
    }
  }

  .backlog {
    margin: 0 0 18px 18px;

    .item {
      padding: 16px 0 14px;
      text-align: center;
      background: #F9F9F9;
      cursor: pointer;

      &:hover {
        theme-background(main);

        div,
        label {
          color: #fff;
        }
      }

      &-box {
        box-sizing: border-box;
        width: 25%;
        padding-right: 10px;
        padding-top: 10px;
        @media screen and (max-width: 1500px) {
          & {
            width: 33.333%;
          }
        }
        @media screen and (max-width: 1100px) {
          & {
            width: 50%;
          }
        }
        @media screen and (max-width: 900px) {
          & {
            width: 100%;
          }
        }
      }

      div {
        margin-bottom: 5px;
        font-size: 30px;
        font-weight: bold;
      }

      label {
        font-size: 13px;
        color: #666;
      }
    }
  }

  .history {
    margin: 0 0 14px 14px;

    .item {
      border: 1px solid #eee;
      line-height: 42px;
      font-size: 14px;
      text-align: center;
      color: #333;
      cursor: pointer;

      &:hover {
        font-weight: bold;
        color: #000;
        theme-border(main);
      }

      &-box {
        box-sizing: border-box;
        width: 16.6666%;
        padding-right: 14px;
        padding-top: 14px;

        @media screen and (max-width: 1800px) {
          & {
            width: 20%;
          }
        }
        @media screen and (max-width: 1600px) {
          & {
            width: 25%;
          }
        }
        @media screen and (max-width: 1300px) {
          & {
            width: 33.3333%;
          }
        }
        @media screen and (max-width: 1000px) {
          & {
            width: 50%;
          }
        }
        @media screen and (max-width: 700px) {
          & {
            width: 100%;
          }
        }
      }
    }
  }
</style>
